import _ from '../../core/utils'
import JOBS_CONFIG from './config'

class JobsClass {
    constructor() {
        this.DOM = {
            section: JOBS_CONFIG.section,
            jobs: JOBS_CONFIG.jobs,
            loader: JOBS_CONFIG.loader
        }

        this.initial = Number
        this.loaded = Number
        this.DOM.section ? this.init() : null
    }

    init() {
        this._initial()
        this._listeners()
    }

    _listeners() {
        this.DOM.loader.addEventListener( 'click', this._load.bind( this ) )
    }

    _initial() {
        // Set initial loader items
        this.initial = parseInt( this.DOM.section.getAttribute( 'data-initial-load' ) ) - 1
        this.loaded = this.initial
        // Hide elements
        this.DOM.jobs.forEach( ( job, key ) => {
            key > this.initial ? _.addClass( job, 'job--hide' ) : null
        })
        // Hide loader if loaded is greater
        this._loadHide()
    }

    _load() {
        // Sum amoun
        this.loaded += this.initial
        // Show elements
        this.DOM.jobs.forEach( ( job, key ) => {
            key < this.loaded ? _.removeClass( job, 'job--hide' ) : null
        })
        // Hide loader if loaded is greater
        this._loadHide()
    }

    _loadHide() {
        let jobsHided = _.selectAll( '.job--hide', this.DOM.section ).length
        console.log( jobsHided )
        jobsHided === 0 ? this.DOM.loader.style.display = 'none' : null
    }


}

const JOBS = new JobsClass()
export default JOBS